// @ts-check
import { indexOfArray } from './indexOfArray';

/**
 *
 * @param {Array<[string, unknown] | [function]>} queue
 * @param {string[]} applyFirst
 * @param {string[]} applyLast
 * @returns {{
 * toApplyFirst: Array<[string, unknown] | [function]>,
 * toApplySecond: Array<[string, unknown] | [function]>,
 * toApplyLast: Array<[string, unknown] | [function]>
 * }}
 */
export function organizeQueue(queue, applyFirst, applyLast) {
  const toApplyFirst = [];
  const toApplySecond = [];
  const toApplyLast = [];

  for (let i = 0; i < queue.length; i++) {
    const item = queue[i];
    if (!item) {
      continue;
    }

    if (indexOfArray(applyFirst, item[0]) > -1) {
      toApplyFirst.push(item);
    } else if (indexOfArray(applyLast, item[0]) > -1) {
      toApplyLast.push(item);
    } else {
      toApplySecond.push(item);
    }
  }

  return {
    toApplyFirst,
    toApplySecond,
    toApplyLast,
  };
}
